import React, { Fragment, useRef, useState } from "react"
import { Dialog, Transition } from "@headlessui/react"

import { BsChevronRight } from "react-icons/bs"
import BookForm from "./forms/bookForm"

export default function ButtonModal({ buttonText, className }) {
  const [openm, setOpenm] = useState(false)

  // function closeModal() {
  //   setOpenm(false)
  // }

  function openModal() {
    setOpenm(true)
  }

  const cancelButtonRef = useRef(null)

  return (
    <>
      <button
        onClick={openModal}
        className={`${className} bg-amber-200 text-slate-900 py-3 px-8 font-playfaird tracking-wider uppercase flex items-center justify-center rounded-sm whitespace-nowrap`}
      >
        <span>{buttonText}</span>
        <BsChevronRight className="ml-2 h-4" />
      </button>

      <Transition.Root show={openm} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpenm}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                  <BookForm />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}
